import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const itemList = createAsyncThunk('finance-item-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-finance-item/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeItem = createAsyncThunk('finance-item-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-finance-item/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editItem = createAsyncThunk('finance-item-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-finance-item/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getItemUnits = createAsyncThunk('finance-item-units', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-finance-item/units`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const itemStockList = createAsyncThunk('finance-item-stock-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-finance-item/stock-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getItemList = createAsyncThunk('canteen-exists-item-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-finance-item/items-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const addItemToStock = createAsyncThunk(
  'finance-add-item-to-stock',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-finance-item/add-item-to-stock`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editItemToStock = createAsyncThunk(
  'finance-edit-item-stock',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-finance-item/edit-item-stock/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type ItemState = {
  errors: any
}

const initialState: ItemState = {
  errors: '',
}

export const financeItemsSlice = createSlice({
  name: 'finance_item',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeItem.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = financeItemsSlice.actions
export default financeItemsSlice.reducer
